import Header from "../Common/Header/Header";
import { useSelector } from "react-redux";
import { useState } from "react";
import EcomSettingsSidebar from "../Common/SideBar/EcomSettingsSidebar";
import CustomerWiseSalesReport from "../Report/SalesReports/CustomerWiseSalesReport";
import GeneralSettings from "./SettingsParts/GeneralSettings";
import BannerSettings from "./SettingsParts/BannerSettings";
import LayoutSettings from "./SettingsParts/LayoutSettings";
import TypographySettings from "./SettingsParts/TypographySettings";
import HeaderSettings from "./SettingsParts/HeaderSettings";
import FooterSettings from "./SettingsParts/FooterSettings";
import ProductPageSettings from "./SettingsParts/ProductPageSettings";
import CheckoutCartSettings from "./SettingsParts/CheckoutCartSettings";
import PartnerApiSettings from "./SettingsParts/PartnerApiSettings";
import ApiKeySettings from "./SettingsParts/ApiKeySettings";

const ECommerceStoreSetup = () => {
  const [active, setActive] = useState("generalSettings");
  const lang = useSelector((state) => state.languageReducer);

  const renderComponent = () => {
    switch (active) {
      case "generalSettings":
        return <GeneralSettings />;
      case "bannerSettings":
        return <BannerSettings />;
      case "layoutSettings":
        return <LayoutSettings />;
      case "typographySettings":
        return <TypographySettings />;
      case "headerSettings":
        return <HeaderSettings />;
      case "footerSettings":
        return <FooterSettings />;
      case "productPageSettings":
        return <ProductPageSettings />;
      case "checkoutCartSettings":
        return <CheckoutCartSettings />;
      case "partnerApiSettings":
        return <PartnerApiSettings />;
      case "apiKeySettings":
        return <ApiKeySettings />;
      default:
        return <GeneralSettings />;
    }
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <EcomSettingsSidebar setActive={setActive} active={active} />
          </div>
          <div className="col-md-10">
            <Header title={lang?.eCommerceStoreSetup}></Header>

            {/* Components */}
            <div
            style={{
              margin: "50px",
              marginLeft: "250px",
              marginRight: "250px",
            }}
            >
              <div>{renderComponent()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ECommerceStoreSetup;
